import React from 'react';
import { HeartIcon, UsersIcon, BabyIcon, SparklesIcon } from 'lucide-react';
export function TreatmentsSection() {
  const treatments = [{
    icon: <HeartIcon className="text-white" size={28} data-id="element-807" />,
    title: 'IVF with Your Own Eggs',
    description: "Ideal for couples with healthy eggs and sperm who have been unable to conceive naturally. Your own eggs are fertilized with your partner's sperm in our advanced laboratories.",
    color: 'from-blue-600 to-blue-700'
  }, {
    icon: <UsersIcon className="text-white" size={28} data-id="element-808" />,
    title: 'IVF with Donor Eggs',
    description: "Eggs from a carefully screened anonymous donor are fertilized with your partner's sperm, offering an excellent option when using your own eggs is not viable.",
    color: 'from-cyan-600 to-cyan-700'
  }, {
    icon: <BabyIcon className="text-white" size={28} data-id="element-809" />,
    title: 'IVF with Donor Embryos',
    description: 'High-quality embryos created from donor eggs and donor sperm are cultivated and prepared for transfer, providing a complete donor solution.',
    color: 'from-blue-500 to-blue-600'
  }, {
    icon: <SparklesIcon className="text-white" size={28} data-id="element-810" />,
    title: 'Combined IVF Cycle',
    description: "A unique approach where both your own and donor eggs are fertilized with your partner's sperm to maximize embryo quantity. Priority is given to embryos from your own eggs for transfer.",
    color: 'from-cyan-500 to-cyan-600'
  }];
  return <section className="py-20 bg-white" data-id="element-811">
      <div className="container mx-auto px-4" data-id="element-812">
        <div className="text-center mb-16" data-id="element-813">
          <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-814">
            <span className="text-blue-700 font-semibold text-sm tracking-wide uppercase" data-id="element-815">
              Treatment Options
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-normal" data-id="element-816">
            Personalized{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600 px-1 py-1 inline-block" data-id="element-817">
              Treatment Plans
            </span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg font-light leading-relaxed" data-id="element-818">
            Our partner clinics offer a range of advanced fertility treatments,
            each tailored to your unique situation and needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-819">
          {treatments.map((treatment, index) => <div key={index} className="group bg-gradient-to-br from-slate-50 to-white border border-slate-100 p-8 rounded-3xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-820">
              <div className={`bg-gradient-to-br ${treatment.color} p-4 rounded-2xl inline-block mb-6 group-hover:scale-110 transition-transform shadow-lg`} data-id="element-821">
                {treatment.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-normal" data-id="element-822">
                {treatment.title}
              </h3>
              <p className="text-slate-600 leading-relaxed font-light" data-id="element-823">
                {treatment.description}
              </p>
            </div>)}
        </div>
        <div className="mt-16 max-w-4xl mx-auto" data-id="element-824">
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-3xl p-8" data-id="element-825">
            <div className="text-center mb-6" data-id="element-826">
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-827">
                Dedicated Support Throughout Your Journey
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-828">
                Each treatment is overseen by a dedicated doctor and supported
                by an English-speaking IVF coordinator who will guide you
                through every step of the process. Our experienced embryologists
                work with the latest technology to continuously improve your
                chances of conception.
              </p>
            </div>
            <div className="text-center" data-id="element-829">
              <a href="/contact" className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 hover:scale-105 font-medium" data-id="element-830">
                Discuss Your Treatment Options
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}